import './App.css'
import { Routes, Route } from 'react-router-dom'
import Home from './screens/Home/Home.jsx'
import Projects from './screens/Projects/Projects'
import Contact from './screens/Contact/Contact'
import About from './screens/About/About'

function App() {
  return (
    <div className='body'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/About' element={<About />} />
      </Routes>
    </div>
  )
}

export default App
